import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'
import Product from './comp-prod'

export default function proses() {

    return (
        <div className="componenet-selesai">
            <div className="transaksi-selesai">
                <Product />
                <div className="status-pengiriman">
                        <h3>Status Pengiriman</h3>
                        <div className="text-kurir">
                            <img src="asset/users/truck.svg" alt="truck" />
                            <p>Paket telah diterima</p>
                        </div>
                    <Link className="link" to="#">Lihat Detail Pengiriman</Link>
                    </div>
                <div className="pembayaran">
                    <h6>Selesai</h6>
                    <p>Total harga barang</p>
                    <h2>Rp. 160.000</h2>
                </div>
            </div>
            <div className="clicked-selesai">
                <div className="time-later-product">
                    <h3 className="mt-3">Pemesanan telah selesai</h3>
                </div>
                <div className="group-tombol">
                    <button type="button">Beli Lagi</button>
                    <a href="https:wa.me/+6285349780521" target="_blank" rel="noopener noreferrer"> 
                        <button type="button" target="_blank">Hubungi Toko</button>
                    </a>
                    <button type="button">Berikan Penilaian</button>
                </div>
            </div>
        </div>
    )
}
